import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image, Card } from "react-bootstrap";

import StartConversationBlock from '../StartConversationBlock'

import AboutBg from "../../Assets/about-bg.png";
import AboutBgSmall from "../../Assets/about-bg-small.png";

export default function ShortDescription() {
    return (
        <section className=''>
            <Container className="padding-section-large">

                {/* Top Section */}
                <Row className="mb-5">

                    {/* Left Text */}
                    <Col md={7}>
                        <h2 className="heading-style-h2 pb-3">At a Glance: <span className="text-gradient-1">Parabola IT</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Shaped by real business demands, not assumptions. </h5>
                    </Col>

                    {/* Right Images */}
                    <Col md={5} className="position-relative">
                        <Image src={AboutBg} className="img-main" />
                        <Image src={AboutBgSmall} className="img-overlay" />
                    </Col>

                </Row>

                {/* Bottom Cards */}
                <Row className='pt-5'>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="shadow-sm rounded-0 primary-border light-bg logo-bg">
                            <Card.Body className='p-4  d-flex flex-column'>
                                <Card.Text className="mb-5">Parabola IT started in 2009 with a very specific challenge, handling the complexities of U.S. sales systems where scale, structure and accuracy truly matter. That early exposure shaped how we think, build and deliver even today. </Card.Text>

                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 secondary-border bg-gradient-1">
                            <Card.Body className='p-4  d-flex flex-column'>
                                <Card.Text className="mb-5">Over time, we’ve grown into a trusted partner for businesses that need systems to work reliably under pressure. From development to quality assurance and DevOps, our focus is simple: Create software that performs consistently, evolves smoothly and holds steady when it matters most. </Card.Text>

                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 secondary-border bg-gradient-2 text-white">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Card.Text className="mb-5">We don’t work as external vendors. We fit into your team, your workflow and your way of working, staying focused on long-term outcomes rather than quick fixes. </Card.Text>
                                <div className="mt-auto">
                                    <Link to="/about" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Learn More About Us</Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <StartConversationBlock />
        </section>
    )
}
